import Axios from 'axios';
import router from './router';
import {getAuthToken, setExpiration} from './storage.js';
// eslint-disable-next-line no-underscore-dangle
// export const apiUrlBase = (window._CONFIGS && window._CONFIGS.apiURL) || 'http://localhost';
export const apiUrlBase = (window._CONFIGS && window._CONFIGS.apiURL) || "https://store.anisen.eu";
// export const apiUrlBase = (window._CONFIGS && window._CONFIGS.apiURL) || "https://store.anisen.fr";
// export const apiUrlBase = (window._CONFIGS !== undefined && window._CONFIGS.apiURL !== undefined) ? window._CONFIGS.apiURL : "https://store.anisen.fr"
export const apiKey = (window._CONFIGS && window._CONFIGS.apiKEY) || 'cf2b2772-7e56-11ea-b51f-0242ac130003';

export const apiVersion = 4;

export const apiAuth = 'auth';
export const apiExchange = 'exch';
export const apiStats = 'stats';
export const apiFiles = 'files';
export const apiModules = 'modules';
export const apiAdmin = 'admin';
export const apiSync = 'sync';
export const apiEval = 'eval';
export const apiTraining = 'training';
export const apiPDF = 'pdf';
export const apiInternal = 'internal';


export const multiPartHeader = {headers: {'Content-type': 'multipart/form-data'}};
export const partHeader = {headers: {'Content-type': 'application/json'}};
export const respTypeBlob = {responseType: 'blob'};

const axiosApi = Axios.create({
  baseURL: apiUrlBase,
  headers: {
    'X-Api-Version': apiVersion,
    'X-Api-Key': apiKey,
  },
});


// add token on each request
axiosApi.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers['X-Auth-Token'] = getAuthToken();
  return config;
});

axiosApi.interceptors.response.use(async (response) => {
    // Prolongement de l'expiration en fonction du serveur
    if (setExpiration(response.headers['x-token-expire-at'])) {
      // si true on force le refraichissement sur le serveur
      const result = axiosApi.refreshtoken();
    }
  return response;
}, async function (error) {
  if (error.response.status === 401 && router.currentRoute.name !== 'Login') {
      router.push('/login');
      return { data: null};
  }
  return error;
});

/**
 * 
 * @returns {boolean} si rafraichissement a pu avoir lieu c'est true sinon c'est une erreur 401
 */
axiosApi.refreshtoken = async function () {
  return await axiosApi.post(`${apiInternal}/refreshtoken`, {})
}

export default axiosApi;
